import React from "react";
import Chip from "@mui/material/Chip";

const statusColors = {
  ready_to_process: { bg: "#ffecb3", text: "#ff9800" },
  processing: { bg: "#bbdefb", text: "#1976d2" },
  processed: { bg: "#b2ebf2", text: "#0097a7" },
  delivered: { bg: "#c8e6c9", text: "#388e3c" },
  Ordered: { bg: "#ffecb3", text: "#ff9800" },
  new: { bg: "#ffecb3", text: "#ff9800" },
  ordered: { bg: "#ffecb3", text: "#ff9800" },
};

const StatusBadge = ({ status }) => {
  const statusLabels = {
    ready_to_process: "Ordered",
    processing: "Processing",
    processed: "Ready to Pick Up",
    delivered: "Picked Up",
    Ordered: "Ordered",
    new: "Ordered",
    ordered: "Ordered",
  };

  const label = statusLabels[status] || "Unknown";
  const { bg, text } = statusColors[status] || { bg: "#e0e0e0", text: "#000" };

  return (
    <Chip
      label={label}
      style={{
        backgroundColor: bg,
        color: text,
        fontWeight: "bold",
      }}
    />
  );
};

export default StatusBadge;
